<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <div class="common-form">费用信息(元)</div>
      <el-form-item label="百融">
        <el-input-number
          v-model="form.bairong"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="e签宝合同">
        <el-input-number
          v-model="form.hetong"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="掌签征信">
        <el-input-number
          v-model="form.zhengxin"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="租先知">
        <el-input-number
          v-model="form.Hv2"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="人脸">
        <el-input-number
          v-model="form.renlian"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="快递100">
        <el-input-number
          v-model="form.kuaidi"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="短信宝">
        <el-input-number
          v-model="form.duanxin"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="ORC">
        <el-input-number
          v-model="form.ORC"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="天狼星">
        <el-input-number
          v-model="form.tianlangxin"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="浩辰达">
        <el-input-number
          v-model="form.hcd"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="法谡征信查询">
        <el-input-number
          v-model="form.fasu_query"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="法谡征信上报">
        <el-input-number
          v-model="form.fasu_report"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="流水报告">
        <el-input-number
          v-model="form.liushui"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading"
          >提交</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";

export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        bairong: 0,
        hetong: 0,
        zhengxin: 0,
        Hv2: 0,
        renlian: 0,
        kuaidi: 0,
        duanxin: 0,
        ORC: 0,
        tianlangxin: 0,
        hcd: 0,
        fasu_query: 0,
        fasu_report: 0,
        liushui: 0
      }
    };
  },
  created() {
    this.getParams();
  },

  methods: {
    /*获取配置数据*/
    getParams() {
      let self = this;
      SettingApi.getRiskAmount({}, true)
        .then(res => {
          let vars = res.data.vars.values;
          self.form.bairong = vars.bairong;
          self.form.hetong = vars.hetong;
          self.form.zhengxin = vars.zhengxin;
          self.form.Hv2 = vars.Hv2;
          self.form.renlian = vars.renlian;
          self.form.kuaidi = vars.kuaidi;
          self.form.duanxin = vars.duanxin;
          self.form.ORC = vars.ORC;
          self.form.tianlangxin = vars.tianlangxin;
          self.form.hcd = vars.hcd;
          self.form.fasu_query = vars.fasu_query;
          self.form.fasu_report = vars.fasu_report;
          self.form.liushui = vars.liushui;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SettingApi.postRiskAmount(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "设置成功",
                type: "success"
              });
              // window.location.reload();
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>
<style>
.tips {
  color: #ccc;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/risk.vue